import React from "react";
import { Link, useNavigate } from "react-router-dom";
import "../pages/blog.css";

function BlogLayout({ children }) {
  const navigate = useNavigate();

  return (
    <div className="blog-page">
      <header className="blog-header">
        <div className="blog-header-inner">
          <Link to="/" className="blog-brand">
            <img
              src="/images/icons/ChapterOneLogo.png"
              alt="ChapterOne Logo"
              className="blog-logo"
            />
            <span>ChapterOne Jobs</span>
          </Link>
          <nav className="blog-nav">
            <Link to="/">Browse Jobs</Link>
            <Link to="/blog">Blog</Link>
            <Link to="/home">About</Link>
            <button
              type="button"
              className="blog-nav-cta"
              onClick={() => navigate("/sign-up")}
            >
              Sign Up Free
            </button>
          </nav>
        </div>
      </header>

      <main className="blog-main">{children}</main>

      <footer className="blog-footer">
        <p>
          Looking for entry-level jobs in California?{" "}
          <Link to="/">Browse open positions</Link>
        </p>
        <p className="blog-footer-copy">
          &copy; {new Date().getFullYear()} ChapterOne Jobs
        </p>
      </footer>
    </div>
  );
}

export default BlogLayout;
